<template lang="html">

  <section class="encabezado row-center line-ppal" v-if="data">

    <h1 >{{$t(`encabezado.${data}`)}}</h1>    
    
    <div class="migas-wrapper" v-if="showMigas">
      <div class="container">
        <migas :inicioPersonalizado="inicioPersonalizado" :last="last" :migasAdicional="migasAdicional"></migas>
      </div>
    </div>

  </section>

</template>

<script lang="js">

  import migas from '@/components/parts/migas';

  import {mapGetters} from 'vuex';

  export default  {
    name: 'encabezado',
    props: ['data','inicioPersonalizado','last','migasAdicional'],
    components : {
      'migas' : migas
    },
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        background : 'getBackground',
        style : 'getStyles'
      }),
      showMigas : function(){
        let forbidden = ['/'];
        return !(forbidden.some(el => el == this.$route.path));
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/parts/encabezado.vue